(function () {
  if (!window.location.pathname.endsWith('/collections/paints')) {
    return;
  }

  const grid = document.getElementById('product-grid');
  if (!grid) {
    return;
  }

  const items = grid.querySelectorAll('.grid__item[data-ovs-paint-product]');
  const pagination = document.querySelector('.pagination-wrapper');

  function parseList(param) {
    const raw = new URLSearchParams(window.location.search).get(param);
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  function selectedFromInputs(selector, dataAttr) {
    return [...document.querySelectorAll(selector)]
      .filter((input) => input.checked)
      .map((input) => input.dataset[dataAttr] || '')
      .filter((value) => value !== '');
  }

  function selectedWithUrlFallback(inputSelector, dataAttr, urlParam) {
    const selected = selectedFromInputs(inputSelector, dataAttr);
    const inputs = document.querySelectorAll(inputSelector);
    if (inputs.length === 0) {
      return parseList(urlParam);
    }

    const knownValues = new Set(
      [...inputs].map((input) => input.dataset[dataAttr] || '').filter((value) => value !== ''),
    );

    parseList(urlParam).forEach((value) => {
      if (! knownValues.has(value) && ! selected.includes(value)) {
        selected.push(value);
      }
    });

    return selected;
  }

  function selectedProducts() {
    return selectedWithUrlFallback('.ovs-paint-product-input', 'ovsPaintProduct', 'ovs_paint_product');
  }

  function selectedApps() {
    return selectedWithUrlFallback('.ovs-paint-app-input', 'ovsPaintApp', 'ovs_paint_app');
  }

  function selectedTypes() {
    return selectedWithUrlFallback('.ovs-paint-type-input', 'ovsPaintType', 'ovs_paint_type');
  }

  function itemMatchesApp(itemAppList, app) {
    if (app === 'pre-thinned-airbrush') {
      return itemAppList.includes('pre-thinned-airbrush');
    }

    if (app === 'airbrush') {
      return itemAppList.includes('airbrush') && !itemAppList.includes('pre-thinned-airbrush');
    }

    return itemAppList.includes(app);
  }

  function itemApps(item) {
    const raw = item.dataset.ovsPaintApps || '';
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  function syncCheckboxLabels() {
    document.querySelectorAll('.ovs-paint-product-input').forEach((input) => {
      const label = input.closest('.ovs-paint-product-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });

    document.querySelectorAll('.ovs-paint-app-input').forEach((input) => {
      const label = input.closest('.ovs-paint-app-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });

    document.querySelectorAll('.ovs-paint-type-input').forEach((input) => {
      const label = input.closest('.ovs-paint-type-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
  }

  function syncCheckboxesFromUrl() {
    const products = parseList('ovs_paint_product');
    const apps = parseList('ovs_paint_app');
    const types = parseList('ovs_paint_type');

    document.querySelectorAll('.ovs-paint-product-input').forEach((input) => {
      const product = input.dataset.ovsPaintProduct || '';
      input.checked = products.includes(product);
    });

    document.querySelectorAll('.ovs-paint-app-input').forEach((input) => {
      const app = input.dataset.ovsPaintApp || '';
      input.checked = apps.includes(app);
    });

    document.querySelectorAll('.ovs-paint-type-input').forEach((input) => {
      const type = input.dataset.ovsPaintType || '';
      input.checked = types.includes(type);
    });

    syncCheckboxLabels();
  }

  function buildUrl(products, apps, types) {
    const url = new URL(window.location.href);
    url.searchParams.delete('ovs_paint_product');
    url.searchParams.delete('ovs_paint_app');
    url.searchParams.delete('ovs_paint_type');
    url.searchParams.delete('page');

    if (products.length > 0) {
      url.searchParams.set('ovs_paint_product', products.join(','));
    }

    if (apps.length > 0) {
      url.searchParams.set('ovs_paint_app', apps.join(','));
    }

    if (types.length > 0) {
      url.searchParams.set('ovs_paint_type', types.join(','));
    }

    return url;
  }

  function updateProductCount(visibleCount) {
    const countNodes = document.querySelectorAll(
      '#ProductCountDesktop, #ProductCountMobile, .product-count__text span',
    );
    countNodes.forEach((node) => {
      if (visibleCount === 1) {
        node.textContent = '1 product';
      } else {
        node.textContent = visibleCount + ' products';
      }
    });
  }

  function togglePagination(products, apps, types) {
    if (!pagination) {
      return;
    }

    pagination.hidden = products.length > 0 || apps.length > 0 || types.length > 0;
  }

  function applyFilters(updateHistory) {
    const products = selectedProducts();
    const apps = selectedApps();
    const types = selectedTypes();
    let visibleCount = 0;

    items.forEach((item) => {
      const itemProduct = item.dataset.ovsPaintProduct || '';
      const itemAppList = itemApps(item);
      const itemType = item.dataset.ovsPaintType || '';
      let show = true;

      if (products.length > 0) {
        show = products.includes(itemProduct);
      }

      if (show && apps.length > 0) {
        show = itemAppList.length > 0 && apps.some((app) => itemMatchesApp(itemAppList, app));
      }

      if (show && types.length > 0) {
        show = itemType !== '' && types.includes(itemType);
      }

      item.hidden = !show;
      if (show) {
        visibleCount += 1;
      }
    });

    syncCheckboxLabels();
    updateProductCount(visibleCount);
    togglePagination(products, apps, types);

    if (updateHistory) {
      const url = buildUrl(products, apps, types);
      window.history.pushState({ ovsPaintFilters: true }, '', url.pathname + url.search);
    }
  }

  document.querySelectorAll('.ovs-paint-product-input, .ovs-paint-app-input, .ovs-paint-type-input').forEach((input) => {
    input.addEventListener('change', () => {
      applyFilters(true);
    });
  });

  window.addEventListener('popstate', () => {
    syncCheckboxesFromUrl();
    applyFilters(false);
  });

  syncCheckboxesFromUrl();
  applyFilters(false);
})();
